<template>
    <div class="or-admin-about">
        <div v-for="(item, i) in options" :key="item.id">
            <or-admin-about-text v-if="item.component === 'or-admin-about-text'" class="card nesting-main" :options="item" @remove="remove(i)" @up="up(i)" @down="down(i)" @unsaved="unsaved"/>
            <or-admin-about-card v-else class="card nesting-main" :options="item" @remove="remove(i)" @up="up(i)" @down="down(i)" @unsaved="unsaved"/>
        </div>
        <p class="add nesting-main hover-pointer hover-yellow" @click="add_text">+ Добавить текстовый блок</p>
        <p class="add nesting-main hover-pointer hover-yellow" @click="add_card">+ Добавить карточку</p>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import orAdminAboutText from '../global/or-admin-about-text.vue'
import orAdminAboutCard from "../global/or-admin-about-card.vue"
export default {
    components: {orAdminAboutText, orAdminAboutCard},
    props: {
        options: Object,
    },
    data() {
        return {
            items: [],
        }
    },
    methods: {
        ...mapActions({addUnsavedPage: 'addUnsavedPage'}),
        unsaved() {
            this.addUnsavedPage({page: 'about'})
        },
        add_text() {
            this.options.push({
                component: 'or-admin-about-text',
                id: this.options.length + 1,
                text: {
                    title: 'Текст',
                    value: '',
                },
            })
            this.addUnsavedPage({page: 'about'})
        },
        add_card() {
            this.options.push({
                component: 'or-admin-about-card',
                id: this.options.length + 1,
                text: {
                    title: 'Текст',
                    value: '',
                },
                radio: {
                    title: 'Расположение картинки:',
                    selected_variant: 0,
                    variants: [
                        'Слева',
                        'Справа'
                    ]
                },
                image: null,
                input_postfix: 'about',
            })
            this.addUnsavedPage({page: 'about'})
        },
        remove(index) {
            this.options.splice(index, 1);
            this.addUnsavedPage({page: 'about'})
        },
        up(index) {
            if (index === 0) return;
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index - 1, 0, item);
            this.addUnsavedPage({page: 'about'})
        },
        down(index) {
            if (index === this.options.length - 1) return
            const item = this.options.splice(index, 1)[0];
            this.options.splice(index + 1, 0, item);
            this.addUnsavedPage({page: 'about'})
        }
    }
    
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .add {
        font-size: 14px;
        line-height: 16px;
        margin-top: 50px;
        text-align: left;
        margin-bottom: 20px;
        color: #3dc986;
    }
    .add:last-of-type {
        margin-top: 0;
        margin-bottom: 50px;
    }
</style>